let body = $( 'body' );

$( document ).ready( function() {
	const swiper = new Swiper('.js-carousel-categories', {
		loop: false,
		slidesPerView: "auto",
		freeMode: true,
		spaceBetween: 6,
		autoplay: {
			delay: 2500,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			320: {
				spaceBetween: 15,
			},
			768: {
				spaceBetween: 6,
			}
		}
	});
	
	const swiper2 = new Swiper('.js-carousel-products', {
		loop: false,
		slidesPerView: "auto",
		freeMode: true,
		spaceBetween: 6,
		autoplay: {
			delay: 2500,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			320: {
				spaceBetween: 15,
			},
			768: {
				spaceBetween: 6,
			}
		}
	});
	
	const swiper3 = new Swiper('.js-relative-products-sep', {
		loop: false,
		slidesPerView: 4,
		freeMode: true,
		spaceBetween: 30,
		navigation: {
			nextEl: '.swiper-button-next-sep',
			prevEl: '.swiper-button-prev-sep',
		},
		autoplay: {
			delay: 2500,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			300: {
				spaceBetween: 15,
				slidesPerView: "auto",
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		}
	});
	const swiper4 = new Swiper('.js-relative-products-bef', {
		loop: false,
		slidesPerView: 4,
		freeMode: true,
		spaceBetween: 30,
		navigation: {
			nextEl: '.swiper-button-next-bef',
			prevEl: '.swiper-button-prev-bef',
		},
		autoplay: {
			delay: 2500,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			300: {
				spaceBetween: 15,
				slidesPerView: "auto",
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		}
	});
	const swiper5 = new Swiper('.js-relative-products-sim', {
		loop: false,
		slidesPerView: 4,
		freeMode: true,
		spaceBetween: 30,
		navigation: {
			nextEl: '.swiper-button-next-sim',
			prevEl: '.swiper-button-prev-sim',
		},
		autoplay: {
			delay: 2500,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			300: {
				spaceBetween: 15,
				slidesPerView: "auto",
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		}
	});
	let gallery = 0;
	if ($( window ).width() < 991) {
		gallery = new Swiper('.product-gallery', {
			loop: false,
			slidesPerView: "auto",
			freeMode: true,
			spaceBetween: 15
		});
	} else {
		if (gallery !== 0) {
			gallery.destroy();
		}
	}
	

	// if ( getCookie( 'cookies' ) !== 'true' ) {
	// 	$.fancybox.open({
	// 		src  : '#cookies',
	// 		touch : false,
	// 		buttons: [
	// 			'close'
	// 		]
	// 	});
	// }
	//
	// if ( getCookie( 'lang' ) !== 'true' ) {
	// 	$.fancybox.open({
	// 		src  : '#lang',
	// 		touch : false,
	// 		buttons: [
	// 			'close'
	// 		]
	// 	});
	// }

	if ( $( window ).width() < 767 ) {
		$( '[data-view="grid"]' ).trigger( 'click' );
	}

	let yourVideo = document.querySelector('.main-banner video');

	if ( yourVideo ) {
		setTimeout( function() {
			yourVideo.addEventListener('suspend', () => {
				$( '.main-banner video:not(.played)' ).addClass( 'suspended' );
			});
		},100);

		yourVideo.addEventListener('play', () => {
			$( '.main-banner video' ).addClass( 'played' ).removeClass( 'suspended' );
		});
	}

	$( '[type="tel"]' ).inputmask( '+38 (099) 999 99 99' );

	$('select:not(.js_select2)').selectric({

		disableOnMobile: false,
		nativeOnMobile: false,
	});


	setTimeout(function () {
		const container = document.querySelector('.mini-cart__products');
		if (container) {
			const ps = new PerfectScrollbar(container);
		}

		const container2 = document.querySelector('.selectric-scroll');
		if (container2) {
			const ps2 = new PerfectScrollbar(container2);
		}

		const container3 = document.querySelector('.dropdown-menu');
		if (container3) {
			const ps3 = new PerfectScrollbar(container3);
		}
	}, 200 );

	$( '[data-fancybox]' ).fancybox({
		touch: false
	});

	$( '[data-fancybox="gallery"]' ).fancybox({
		touch: true
	});

	$( '.article-text video' ).wrap('<div class="video-wrap"></div>');
	$( '.sizes-item table' ).wrap('<div class="table-wrap"></div>');
});

body.on( 'click', '.js-seo-text-more', function() {
	$( '.seo-text__content' ).toggleClass( 'active' );
	$( this ).toggleClass( 'active' );
	if ( $( this ).hasClass( 'active' ) ) {
		$( this ).text( $( this ).data( 'less' ) );
	} else {
		$( this ).text( $( this ).data( 'more' ) );
	}
});

body.on( 'click', '.header__nav-toggle', function() {
	$( '.mob-panel' ).fadeIn();
	$( 'body, html' ).addClass( 'no-scroll' );
});

body.on( 'click', '.product-button-cart', function() {
	setTimeout( function () {
		let container4 = document.querySelector('.mini-cart__products');
		let ps4 = new PerfectScrollbar(container4);
	}, 500);
});

body.on( 'click', '.qty_btn', function() {
	setTimeout( function () {
		let container4 = document.querySelector('.mini-cart__products');
		let ps4 = new PerfectScrollbar(container4);
	}, 500);
});

body.on( 'click', '.remove_from_cart', function() {
	setTimeout( function () {
		let container4 = document.querySelector('.mini-cart__products');
		let ps4 = new PerfectScrollbar(container4);
	}, 500);
});

body.on( 'click', '.mob-panel__close', function() {
	$( '.mob-panel' ).fadeOut();
	$( 'body, html' ).removeClass( 'no-scroll' );
});

body.on( 'click', '.overlay', function() {
	$( this ).fadeOut();
	$( '.catalog-filter' ).removeClass( 'active' );
	$( 'body, html' ).removeClass( 'no-scroll' );
});

body.on( 'click', '.catalog-filter__close', function() {
	$( '.overlay' ).fadeOut();
	$( '.catalog-filter' ).removeClass( 'active' );
	$( 'body, html' ).removeClass( 'no-scroll' );
});

body.on( 'click', '.filter-toggle', function() {
	$( '.overlay' ).fadeIn();
	$( '.catalog-filter' ).addClass( 'active' );
	$( 'body, html' ).addClass( 'no-scroll' );
});

body.on( 'click', '.catalog-view__item', function() {
	$( this).addClass( 'active' ).siblings().removeClass( 'active' );
	if ( $( this ).data( 'view' ) === 'grid' ) {
		$( '.catalog-grid' ).addClass( 'grid' );
	} else {
		$( '.catalog-grid' ).removeClass( 'grid' );
	}
});

body.on( 'click', '.tabs span', function() {
	$( this).addClass( 'active' ).siblings().removeClass( 'active' );
	$( '.tabs-content > *' ).eq( $( this ).index() ).addClass( 'active' ).siblings().removeClass( 'active' );;
});

body.on( 'click', '.product-accordion__title', function() {
	$( this).toggleClass( 'active' );
	$( this ).next().slideToggle();
});

// body.on( 'click', '.js-mini-cart-close', function() {
// 	$( '.mini-cart' ).fadeOut();
// });
//
// body.on( 'click', '.js-mini-cart-open', function() {
// 	$( '.mini-cart' ).fadeIn();
// });

body.on( 'click', '.js-all-modal-close', function() {
	$.fancybox.close();
});

body.on( 'click', '.search-toggle > i', function() {
	$( '.search-toggle' ).toggleClass( 'active' );
	$( '.header__search' ).fadeIn();
	$( '.header__nav' ).fadeOut();
});


document.addEventListener("click", (evt) => {
	if ( $( window ).width() > 1199 ) {
		const flyoutEl = document.querySelector('.search-toggle');
		let targetEl = evt.target; // clicked element
		do {
			if(targetEl == flyoutEl) {
				// This is a click inside, does nothing, just return.
				return;
			}
			// Go up the DOM
			targetEl = targetEl.parentNode;
		} while (targetEl);
		// This is a click outside.
		$( '.header__search' ).fadeOut();
		$( '.header__nav' ).fadeIn();
		$( '.search-toggle' ).removeClass( 'active' );
	}
});


// document.addEventListener("click", (evt) => {
// 	const flyoutEl = document.querySelector('.header-cart');
// 	let targetEl = evt.target; // clicked element
// 	do {
// 		if(targetEl == flyoutEl) {
// 			// This is a click inside, does nothing, just return.
// 			return;
// 		}
// 		// Go up the DOM
// 		targetEl = targetEl.parentNode;
// 	} while (targetEl);
// 	// This is a click outside.
// 	$( '.mini-cart' ).fadeOut();
// });

body.on( 'click', '.video-wrap', function() {
	let video =  $( this ).find( 'video' );
	$( this ).toggleClass( 'active' );

	if ( !video[0].paused ) {
		video[0].pause();
	} else {
		video[0].play();
	}
});

body.on( 'click', '.password-toggle', function() {
	let toggle = $( this );
	let input = $( this ).siblings( 'input' );
	toggle.toggleClass( 'active' );
	if ( toggle.hasClass( 'active' ) ) {
		input.attr( 'type', 'text' );
	} else {
		input.attr( 'type', 'password' );
	}
});


var lastScrollTop = 0;

$(window).scroll(function(event){
	if ($(this).scrollTop() > 0) {
		$( 'header' ).addClass( 'scrolled' );
	} else {
		$( 'header' ).removeClass( 'scrolled' );
	}
});

function paginationProgress() {
	if ( $( '.pagination-progress' ).length > 0 ) {
		let el = $( '.pagination-progress span' );
		let showed = el.data( 'showed' );
		let total = el.data( 'total' );
		let width = showed / total * 100;
		el.css( {'width': width + '%'} );
	}
}

function setCookie( key, value ) {
	var currentDate = new Date();
	currentDate.setDate(currentDate.getDate() + 1);
	var expires = "expires=" + currentDate.toUTCString();
	document.cookie = key + "=" + value + "; " + expires;
}

function getCookie(key) {
	var name = key + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieArray = decodedCookie.split(';');
	for (var i = 0; i < cookieArray.length; i++) {
		var cookie = cookieArray[i];
		while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1);
		}
		if (cookie.indexOf(name) === 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}
	return "";
}

// function openMiniCart() {
// 	$( '.mini-cart' ).fadeIn();
// }

paginationProgress();
